function setupRevealAnimations() {
	// Do nothing if IntersectionObserver isn't supported
	if (!("IntersectionObserver" in window)) {
		console.log("IntersectionObserver is not supported");
		return false;
	}

	// Do nothing if :has() isn't supported
	if (!CSS.supports("selector(:has(p))")) {
		console.log(":has() is not supported");
		return false;
	}

	// Do nothing if browser is set to reduced motion
	if (!window.matchMedia("(prefers-reduced-motion: no-preference)")) {
		console.log("browser either doesn't support prefers-reduced-motion or is set to prefers-reduced-motion: reduced");
		return false;
	}

	const observerThreshold = 0;

	// Elements we want to animate but don't have markup control over
	var targets_self = [".hero #hero_text_block", ".wp-block-cover > .wp-block-cover__inner-container"];
	var targets_children = [
		// ".header a[rel='home']", // header logo
		// ".header .navbar-nav", // primary nav
		// ".header #menu-secondary-nav", // secondary nav
		".wp-block-columns",
		".wp-block-gallery",
		".wp-block-media-text",
		".entry-content > .wp-block-group",
		".row.newsletter", // the footer newsletter thing
		"#footer > .container > .row:first-child", // the footer columns
		// "#footer .menu", // the footer menus
	];

	// Add data-reveal attribute to above elements
	var elements_children = document.querySelectorAll(targets_children.join(", "));
	elements_children.forEach(function (element) {
		if (element.classList.contains("disable-animations") || element.matches(":has([data-reveal])")) {
			return false;
		}

		element.setAttribute("data-reveal", "children");
	});

	var elements_self = document.querySelectorAll(targets_self.join(", "));
	elements_self.forEach(function (element) {
		if (element.classList.contains("disable-animations") || element.matches(":has([data-reveal])")) {
			return false;
		}

		element.setAttribute("data-reveal", "self");
	});

	// Add observers
	var sectionObserver = new IntersectionObserver(
		function (entries, observer) {
			var anyAreIntersecting = false;
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.setAttribute("data-reveal-state", "visible");
				}
			});
		},
		{ threshold: observerThreshold }
	);

	var sections = document.querySelectorAll("[data-reveal]");
	sections.forEach(function (element) {
		element.setAttribute("data-reveal-state", "watching");
		sectionObserver.observe(element);
	});
}

setupRevealAnimations();
